// @mui material components
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MDBox from "components/MDBox";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";

import SlidingComponent from "./sections/slidingComponent";
import Projects from "./sections/Projects";
import FAQ from "./sections/FAQ";
import CenteredFooter from "examples/Footers/CenteredFooter";

function AboutUs() {
  return (
    <>
      <DefaultNavbar transparent light />
      <SlidingComponent />
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <section id="projects">
          <Projects />
        </section>
        <section id="faqs">
          <FAQ />
        </section>
      </Card>
      <MDBox px={1}>
        <CenteredFooter />
      </MDBox>
    </>
  );
}

export default AboutUs;
